import React from 'react';
import ResetPassComponent from '../../components/ResetPassword/reset_pass_component';

class ResetPassPage extends React.Component {
  render() {
    return (
      <ResetPassComponent />
    );
  }
}

export default ResetPassPage;
